import { actions } from 'forms/rrf';
import { toast } from 'react-toastify';
import {
  GET_NON_PPC_MC_SETTINGS_FULFILLED,
  GET_NON_PPC_MC_SETTINGS_PENDING,
  GET_NON_PPC_MC_SETTINGS_REJECTED
} from '../reducers/nonPpcSettingsReducer';
import irelandApi from '../irelandApi';
import ToastMessage from '../components/common/toast-message';

export const getNonPpcMcSettings = () => (dispatch) => {
  dispatch({
    type: GET_NON_PPC_MC_SETTINGS_PENDING
  });

  return irelandApi.get('/api/admin/non_ppc_mc_settings')
    .then((response) => {
      const { attributes } = response.data.data;
      const firstPointRedemptionDate = attributes['point-redemption-dates'].shift();
      const settings = {
        point_redemption_date: firstPointRedemptionDate,
        point_redemption_dates: attributes['point-redemption-dates'] || []
      };

      dispatch(actions.load('deep.admin_non_ppc_mc_settings', settings));
      dispatch({ type: GET_NON_PPC_MC_SETTINGS_FULFILLED, payload: response.data });
    })
    .catch((error) => {
      dispatch({
        type: GET_NON_PPC_MC_SETTINGS_REJECTED,
        payload: error.data
      });
    });
};

export const saveNonPpcMcSettings = (payload) => {
  const data = {
    point_redemption_dates: [payload.point_redemption_date, ...payload.point_redemption_dates]
  };

  return irelandApi.patch('/api/admin/non_ppc_mc_settings', { non_ppc_mc_setting: data })
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Non ppc mc settings saved successfully" />);
    })
    .catch((error) => {
      const errorData = {
        ...error.response.data
      };
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save non ppc mc settings" />);
      return Promise.reject(errorData);
    });
};

export const downloadCsvExport = (fromDate, toDate) =>
  irelandApi.get('/api/admin/non_ppc_mc_loads/csv', { params: { fromDate, toDate }});
